export const BASE_API = '/fakeApi';

export const CUSTOMERS_API = `${BASE_API}/customers`;
export const CUSTOMER_API = (cid: string) => `${CUSTOMERS_API}/${cid}`;
export const CUSTOMER_DOCUMENTS_API = (cid: string) => `${CUSTOMER_API(cid)}/documents`;
export const CUSTOMER_PRODUCTS_API = (cid: string) => `${CUSTOMER_API(cid)}/products`;
export const DOCUMENTS_API = `${BASE_API}/documents`;
